var staticData = {
  passedEventNotification: 'Dit event is verlopen'
};
export default staticData;